export default __webpack_public_path__ + "static/fiq-9341741292b99a7304365feb11da5fa2.png";